const pickFirstDefined = (...values) => values.find((value) => typeof value === "string" && value.trim());

export const buildLmsCredential = (payload, fallback = {}) => {
  const token = pickFirstDefined(
    payload?.token,
    payload?.accessToken,
    payload?.bearerToken,
    payload?.TEACHER_PARENT_BEARER_TOKEN,
    payload?.data?.token,
    payload?.data?.accessToken,
    payload?.data?.bearerToken,
    payload?.data?.TEACHER_PARENT_BEARER_TOKEN,
    payload?.data?.auth?.token,
    fallback?.token
  );
  const refreshToken = pickFirstDefined(
    payload?.refreshToken,
    payload?.data?.refreshToken,
    payload?.data?.auth?.refreshToken,
    fallback?.refreshToken
  );

  return {
    token,
    refreshToken,
    lmsRole: fallback?.lmsRole || payload?.data?.lmsRole || payload?.data?.role,
    user: payload?.data || fallback?.user,
  };
};

export const hasValidJwtSession = (credObj) => Boolean(credObj?.token && credObj?.refreshToken);
